import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useForgotPassword } from '../Login/api';
import { useNavigate } from 'react-router-dom';
import { useModalContext } from '../../contexts/ModalContext';
import Loader from '../../Loader/buttonLoad';
import { useTranslation } from 'react-i18next';

const ResetPassword = (props) => {
    const {t} = useTranslation();
    const navigate = useNavigate()
    const validationSchema = Yup.object({
        email: Yup.string().email(t("Invalid email format")).required(t("Email is required")),
    });

    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        resolver: yupResolver(validationSchema)
    });
    const forgotPassword = useForgotPassword()
    const { isloading, setIsloading } = useModalContext();

    const onSubmit = async (data) => {
        setIsloading(true)
        try {
            const res = await forgotPassword.mutateAsync(data)
            if (res?.status) {
                reset({
                    email: '',
                })
                navigate('/')
            }

        } catch (error) {
            setIsloading(false)

        } finally {
            setIsloading(false)
        }
    };
    return (
        <>
            {isloading && <Loader />}

            <div className="AuthPg">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-5 col-lg-8">
                            <div className="AuthBgFrm">
                                <h3>{t('Reset password')}</h3>
                                <p>{t('If you forgot your password, well, then we’ll email you instructions to reset your password.')}</p>
                                <form onSubmit={handleSubmit(onSubmit)}>

                                    <div className="form-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder={t("Your Email")}
                                            {...register('email')}
                                        />
                                        {errors.email && <p className="text-danger">{errors.email.message}</p>}
                                    </div>
                                    <div className="form-group">
                                        <button className='btn CmnBtn w-100 h-46'>{t('Send Reset Link')}</button>
                                    </div>
                                    <div className="form-group">
                                        <a href='/login' className="d-block text-center" >{t('Return to Login')}</a>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
}

export default ResetPassword;